import { FilterMatchMode } from 'primereact/api'

import { ColumnConfig } from '../../../../features/ui-config'

export function getFilterMatchMode(dataType: ColumnConfig['dataType']) {
  switch (dataType) {
    case 'date':
    case 'forecastDate':
      return FilterMatchMode.DATE_IS
    case 'active':
    case 'alcType':
    case 'attachmentCategory':
    case 'boolean':
    case 'currency':
    case 'day':
    case 'decimal':
    case 'delForProcessCompletion':
    case 'delForProcessIsActive':
    case 'deliveryStatus':
    case 'deliveryType':
    case 'number':
    case 'orderProcessCompletion':
    case 'orderProcessIsActive':
    case 'packagingIdentifier':
    case 'percent':
    case 'price':
    case 'project':
    case 'propertyIdentifier':
    case 'packagingType':
    case 'role':
    case 'status':
    case 'unitOfWeight':
      return FilterMatchMode.EQUALS
    case 'attachmentStatus':
    case 'string':
    default:
      return FilterMatchMode.STARTS_WITH
  }
}
